import React from 'react';
import Valedictionceremony6to82023 from 'views/Valedictionceremony6to82023'

const SchoolProgrampage = () => {
  return <Valedictionceremony6to82023 />;
};

export default SchoolProgrampage;